import React, { useCallback, useContext, useEffect, useState } from 'react';
import './Components/FilterPapers.css';
import FilterPanel from './Components/FilterPanel';
import PaperTable from './Components/PaperTable';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { MainContext } from '../../../../../context/main/main-context';
import { debounce } from 'lodash';
import { ASSESSMENT_STUDENT_FILTERS } from '../../../../../helper/constants';
import { Yard } from '@mui/icons-material';
import Type from '../../../subscription/Type';
import ExamsHeaderTabs from '../ExamsHeaderTabs';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 450,
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: 24,
  p: 3,
  maxHeight: '90vh',
  overflowY: 'auto',
};

export default function PaperFilterLayout(
  { userType,
    onFilterChange,
    filterKeys = [],
    isShowExamStatus = false,
    showHeader = false,
    value,
    handleChange,
    customerPaperText,
    availablePaperControl,
    enrollPaperControl
  }) {

  const {
    assessment_filter_data_initial_loading,
    assessment_filter_data_loading,
    assessment_filter_data,
    fetchAssessmentFilterdData } = useContext(MainContext)

  const [selectedFilters, setSelectedFilters] = useState({
    Subject: [],
    Grade: [],
    Status: [],
    Source: [],
    Author: [],
    Category: [],
    Exam_Category: [],
    Chapter: [],
    Difficulty: [],
    Language: [],
    Created_By: [],
    Reviewers: [],
    Term: [],
    Exam_Status: ['null'],
    StartDate: "",
    EndDate: "",
    Year: [],
    Type: [],

  });

  const [filterOptions, setFilterOptions] = useState(assessment_filter_data)



  const [visibleFilterOptions, setVisibleFilterOptions] = useState([])

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handlefetchAllMyAssessments = useCallback(
    debounce(async () => {

      try {

        await fetchAssessmentFilterdData();

      } catch (error) {
        console.error('Error fetching assessments filter data', error);
      }
    }, 300),
    []);

  useEffect(() => {

    handlefetchAllMyAssessments()

  }, []);

  useEffect(() => {
    if (assessment_filter_data && assessment_filter_data.length > 0) {
      const parsedFilters = {};

      assessment_filter_data.forEach((item) => {
        const key = Object.keys(item)[0];
        parsedFilters[key] = item[key];
      });


      parsedFilters["Exam_Status"] = [
        {
          exam_status: "All",
          exam_status_id: "null"
        },
        {
          exam_status: "Not Started",
          exam_status_id: "Upcoming"
        },
        {
          exam_status: "Started",
          exam_status_id: "Onprogress"
        },
        {
          exam_status: "Completed",
          exam_status_id: "Finished"
        },
      ]


      setFilterOptions(parsedFilters);
    }
  }, [assessment_filter_data]);

  // Auto set filters based on user type
  useEffect(() => {
    if (userType === "student") {
      const user_grade = Number(sessionStorage.getItem("studentGrade"));
      const user_medium = Number(sessionStorage.getItem("studentMedium"));

      setSelectedFilters((prev) => ({
        ...prev,
        Grade: prev.Grade?.includes(user_grade)
          ? prev.Grade
          : [...(prev.Grade || []), user_grade],
        Language: prev.Language?.includes(user_medium)
          ? prev.Language
          : [...(prev.Language || []), user_medium],
      }));

      // } else if (userType === "TEACH") {
      //   const user_subject = Number(sessionStorage.getItem("teacherSubject"));

      //   setSelectedFilters((prev) => ({
      //     ...prev,
      //     Subject: prev.Subject?.includes(user_subject)
      //       ? prev.Subject
      //       : [...(prev.Subject || []), user_subject],
      //   }));

    }
  }, [userType, assessment_filter_data]);

  // Decide visible filter options based on user type
  useEffect(() => {
    // Add StartDate and EndDate so they can be controlled by filterKeys prop
    const availableFilterKeys = [...Object.keys(filterOptions || {}), 'StartDate', 'EndDate'];
    let visibleFilterKeys = availableFilterKeys;

    visibleFilterKeys = availableFilterKeys.filter((key) =>
      filterKeys.includes(key)
    )



    // if (userType === "student" || userType === "parent") {
    //   visibleFilterKeys = availableFilterKeys.filter((key) =>
    //     ASSESSMENT_STUDENT_FILTERS.includes(key)
    //   );
    // } else if (userType === "DEOP" || userType === "TEACH"||userType==="MASAD") {
    //   if (userType === "TEACH") {
    //     const mainFilters = [
    //       "Grade",
    //       "Subject",
    //       "Language",
    //       "Status",


    //     ];
    //     visibleFilterKeys = availableFilterKeys.filter((key) =>
    //       mainFilters.includes(key)
    //     );
    //   } else if (userType === "DEOP"||userType==="MASAD") {
    //     visibleFilterKeys = availableFilterKeys.filter((key) =>
    //       filterKeys.includes(key)
    //     )
    //   }

    // }

    setVisibleFilterOptions(visibleFilterKeys);

  }, [filterOptions, userType]);

  const handleSetSelectedFilters = (newFilters) => {

    setSelectedFilters(newFilters)
    onFilterChange(newFilters)
  }

  return (

    <div className="">

      <ExamsHeaderTabs
        showHeader={showHeader}
        value={value}
        handleChange={handleChange}
        customerPaperText={customerPaperText}
        availablePaperControl={availablePaperControl}
        enrollPaperControl={enrollPaperControl}
      />

      <div className='MobileFilter'>
        <div className="d-md-none text-start px-0 pt-0">
          <button
            onClick={handleOpen}
            className="btn ph-filter-toggle-button"
            aria-label="Open Filters"
          >
            <TuneRoundedIcon className="ph-filter-icon" />
            <span className="ph-filter-text">Filters</span>
          </button>
        </div>


        <Modal open={open} onClose={handleClose}>
          <Box sx={modalStyle}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="mobfilTopic">Filters</p>
              <IconButton
                onClick={handleClose}
                size="small"
                aria-label="close"
                sx={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: '#333',
                }}
              >
                <CloseIcon />
              </IconButton>

              <button
                className="btn-close"
                onClick={handleClose}
                style={{ border: 'none', background: 'none' }}
                aria-label="Close"
              />
            </div>
            <FilterPanel
              userType={userType}
              selectedFilters={selectedFilters}
              setSelectedFilters={handleSetSelectedFilters}
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
              visibleFilterOptions={visibleFilterOptions}
              isShowExamStatus={isShowExamStatus}
            />
          </Box>
        </Modal>
      </div>


      <div className="row mt-2">
        <div className="col-md-12 d-none d-md-block px-0">
          <FilterPanel
            userType={userType}
            selectedFilters={selectedFilters}
            setSelectedFilters={handleSetSelectedFilters}
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            visibleFilterOptions={visibleFilterOptions}
            isShowExamStatus={isShowExamStatus}
          />
        </div>
        {/* <div className="col-12 col-md-9">
          <PaperTable />
        </div> */}

      </div>

    </div>
  );
}
